export const CARD_FRAME_CLASSNAME = 'bg-bg-primary border-border-100 rounded-xl border'

export const CARD_PADDING_CLASSNAME = 'tablet:px-5 px-4 py-3.5'
